import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./slices";

import { loginSuccess } from "./slices/auth/login/reducer";

const store = configureStore({ reducer: rootReducer, devTools: true });

// Hydrate the store on load
try {
  const authUser = localStorage.getItem("authUser");
  if (authUser) {
    store.dispatch(loginSuccess(JSON.parse(authUser)));
  }
} catch (error) {
  console.error("Could not re-hydrate user from localStorage", error);
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <React.Fragment>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <App />
      </BrowserRouter>
    </React.Fragment>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();